<template>
  <transition name="screenslideup">
    <div v-show="true" class="modal-overlay">
      <div class="modal" style="height: 85vh;">
        <table border="0" width="90%">
          <tr>
            <td>
              <div class="divl" style="height: 6vh">
                <button class="text-only-button cancel" @click="doCancel">Cancel</button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="wrapper-todiv" style="height: 8vh">
                <div>
                  <img class="tulogo" style="height: 7vh;" alt="ThankU logo" src="../assets/tutxtlogo.png">
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td style="display: flex;">
              <div class="lt-blue notes-text" style="width: 100%">
                Please provide your details as they appear on your bank account and identification documents.
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 6vh; display: flex;">
                <input 
                  type="text" 
                  class="standard-textbox input" 
                  ref="firstName" 
                  placeholder="First name"
                  style="min-width: 71%;"
                  v-model="personalDetails.bankFirstName"
                >
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 6vh; display: flex;">
                <input 
                  type="text" 
                  class="standard-textbox input" 
                  ref="lastName" 
                  placeholder="Last name"
                  style="min-width: 71%;"
                  v-model="personalDetails.bankLastName"
                >
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 6vh; display: flex;">
                <input 
                  type="date" 
                  class="standard-textbox input" 
                  ref="dateOfBirth" 
                  placeholder="Date of birth"
                  style="min-width: 71%;"
                  v-model="personalDetails.bankDateOfBirth"
                >
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 6vh; display: flex;">
                <input 
                  type="text" 
                  class="standard-textbox input" 
                  ref="addressLine1" 
                  placeholder="Address line 1"
                  style="min-width: 71%;"
                  v-model="personalDetails.bankAddressLine1"
                >
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 6vh; display: flex;">
                <input 
                  type="text" 
                  class="standard-textbox input" 
                  ref="addressLine2" 
                  placeholder="Address line 2 (optional)"
                  style="min-width: 71%;"
                  v-model="personalDetails.bankAddressLine2"
                >
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 6vh; display: flex;">
                <input 
                  type="text" 
                  class="standard-textbox input" 
                  ref="city" 
                  placeholder="City"
                  style="min-width: 71%;"
                  v-model="personalDetails.bankAddressCity"
                >
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="height: 6vh; display: flex;">
                <input 
                  type="text" 
                  class="standard-textbox input" 
                  ref="postalCode" 
                  placeholder="Postal code"
                  style="min-width: 71%;"
                  v-model="personalDetails.bankAddressPostCode"
                >
              </div>
            </td>
          </tr>
          <tr>
            <td style="height: 10vh">
              <div>
                <button 
                  class="widebtn" 
                  style="width: 70%; height: 5vh;" 
                  @click="doSavePersonalDetails"
                >
                  Continue
                </button>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </transition>
</template>

<script>

import shared from '../shared.js';

export default {
  name: 'PersonalDetailsScreen',
  props: {
    userData: shared.userDataStruct(),
  },
  data() {
    return {
      fontSizeTitle: 2.7,
      fontSizeTitleLineHeight: 5,
      personalDetails: {
        bankFirstName: '',
        bankLastName: '',
        bankDateOfBirth: '',
        bankAddressLine1: '',
        bankAddressLine2: '',
        bankAddressCity: '',
        bankAddressPostCode: ''
      }
    }
  },
  methods: {
    doCancel() {
      this.$emit('next-action', {
        nextScreen: 'showAccountScreen',
      });
    },
    
    validatePersonalDetails() {
      const details = this.personalDetails;
      
      if (!details.bankFirstName || details.bankFirstName.trim().length < 2) {
        return 'First name must be at least 2 characters';
      }
      
      if (!details.bankLastName || details.bankLastName.trim().length < 2) {
        return 'Last name must be at least 2 characters';
      }
      
      if (!details.bankDateOfBirth) {
        return 'Date of birth is required';
      }
      
      // Check if user is at least 18 years old
      const today = new Date();
      const birthDate = new Date(details.bankDateOfBirth);
      const age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      
      // if (age < 18 || (age === 18 && monthDiff < 0) || 
      //     (age === 18 && monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      //   return 'You must be at least 18 years old';
      // }
      
      if (!details.bankAddressLine1 || details.bankAddressLine1.trim().length < 5) {
        return 'Address line 1 must be at least 5 characters';
      }
      
      if (!details.bankAddressCity || details.bankAddressCity.trim().length < 2) {
        return 'City must be at least 2 characters';
      }
      
      if (!details.bankAddressPostCode || details.bankAddressPostCode.trim().length < 3) {
        return 'Postal code must be at least 3 characters';
      }
      
      return null;
    },
    
    async doSavePersonalDetails() {
      const validationError = this.validatePersonalDetails();
      
      if (validationError) {
        this.$emit('show-popup', {
          title: 'Oops',
          body: validationError
        });
        return;
      }
      
      try {
        // Save personal details using existing saveUserFromWebApp function
        const Parse = require('parse/node');
        let params = {
          userObjectId: window.localStorage.getItem("tuob"),
          bankFirstName: this.personalDetails.bankFirstName.trim(),
          bankLastName: this.personalDetails.bankLastName.trim(),
          bankDateOfBirth: this.personalDetails.bankDateOfBirth,
          bankAddressLine1: this.personalDetails.bankAddressLine1.trim(),
          bankAddressLine2: this.personalDetails.bankAddressLine2.trim(),
          bankAddressCity: this.personalDetails.bankAddressCity.trim(),
          bankAddressPostCode: this.personalDetails.bankAddressPostCode.trim(),
          bankPersonalDetailsSubmitting: true
        };
        
        await Parse.Cloud.run("saveUserFromWebApp", params);
        
        // Update userData and proceed to document upload
        this.userData.bankPersonalDetailsCompleted = true;
        
        this.$emit('next-action', {
          nextScreen: 'showDocumentUpload',
          userData: this.userData
        });
        
      } catch (e) {
        this.$emit('show-popup', {
          title: 'Sorry',
          body: 'Failed to save personal details: ' + e.message
        });
      }
    }
  },
  
  mounted() {
    // Load existing bank data if available
    if (this.userData && this.userData.bankPersonalDetails) {
      this.personalDetails = { ...this.userData.bankPersonalDetails };
    } else if (this.userData) {
      // Load individual bank fields if they exist
      this.personalDetails.bankFirstName = this.userData.bankFirstName || '';
      this.personalDetails.bankLastName = this.userData.bankLastName || '';
      this.personalDetails.bankDateOfBirth = this.userData.bankDateOfBirth || '';
      this.personalDetails.bankAddressLine1 = this.userData.bankAddressLine1 || '';
      this.personalDetails.bankAddressLine2 = this.userData.bankAddressLine2 || '';
      this.personalDetails.bankAddressCity = this.userData.bankAddressCity || '';
      this.personalDetails.bankAddressPostCode = this.userData.bankAddressPostCode || '';
    }
  }
}
</script>